
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting errors specific to the Transactions product.',
  title: 'Transactions'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Transactions errors' subtitle='Guide to troubleshooting Transactions errors' mdxType="Header" />
    <h4 {...{
      "id": "transactions_sync_mutation_during_pagination"
    }}><strong parentName="h4">{`TRANSACTIONS_SYNC_MUTATION_DURING_PAGINATION`}</strong></h4>
    <ErrorReference type='TRANSACTIONS_ERROR' error='TRANSACTIONS_SYNC_MUTATION_DURING_PAGINATION' subtitle="Transaction data was updated during pagination." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`Transaction data was updated during pagination. This can occur when calling the `}<inlineCode parentName="li">{`/transactions/sync`}</inlineCode>{` endpoint.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Restart the pagination loop beginning at the original cursor value used for the first request in the pagination loop. Note that the entire loop must be restarted, beginning with the first request whose response included a `}<inlineCode parentName="p">{`true`}</inlineCode>{` value for `}<inlineCode parentName="p">{`has_more`}</inlineCode>{`. If you attempt to re-run only the requests using the cursor value where this error was encountered, without restarting the entire loop, the error will recur. The request loop must be run until `}<inlineCode parentName="p">{`has_more`}</inlineCode>{` is `}<inlineCode parentName="p">{`false`}</inlineCode>{`.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`To reduce the frequency of this error, you can increase the `}<inlineCode parentName="p">{`count`}</inlineCode>{` parameter in the `}<inlineCode parentName="p">{`/transactions/sync`}</inlineCode>{` from the default value of 100 to a higher value, such as the maximum of 500, which will reduce the number of pages in the API response.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "transactions_sync_item_limit_exceeded"
    }}><strong parentName="h4">{`TRANSACTIONS_SYNC_ITEM_LIMIT_EXCEEDED`}</strong></h4>
    <ErrorReference type='TRANSACTIONS_ERROR' error='TRANSACTIONS_SYNC_ITEM_LIMIT_EXCEEDED' subtitle='The Item has an excessively large transaction history and exceeds the size limit for starting or restarting Transactions Sync.' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`Calling `}<inlineCode parentName="li">{`/transactions/sync`}</inlineCode>{` or `}<inlineCode parentName="li">{`/processor/transactions/sync`}</inlineCode>{` without a cursor for an Item with an excessively large transaction history.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Do not automatically retry the failed request or restart pagination from an empty cursor. Reducing the `}<inlineCode parentName="p">{`count`}</inlineCode>{` parameter does not resolve this error.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`If your integration has a previously saved cursor for this Item, preserve it and continue syncing from that cursor.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`If you need to retrieve transactions without an existing cursor, use `}<inlineCode parentName="p">{`/transactions/get`}</inlineCode>{` or `}<inlineCode parentName="p">{`/processor/transactions/get`}</inlineCode>{`, as applicable.`}</p>
      </Checkbox>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "transactions_sync_mutation_during_pagination",
        level: 4,
        title: "TRANSACTIONS_SYNC_MUTATION_DURING_PAGINATION",
      },
{
        id: "transactions_sync_item_limit_exceeded",
        level: 4,
        title: "TRANSACTIONS_SYNC_ITEM_LIMIT_EXCEEDED",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
